import React, { useState } from 'react';

import SingleColumnMenu from './desktop/SingleColumnMenu';
import { telemetryClickHandler } from './telemetryHandler';
import type { ActionItemConfig } from './types';

interface IconActionProps {
  item: ActionItemConfig & { type: 'icon' };
  linkLabelClassName?: string;
}

export default function IconAction({
  item,
  linkLabelClassName = 'ml-2 text-sm font-normal text-gray-900',
}: IconActionProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  const chevronSvg = item.chevron ? (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={{
        transition: 'transform 0.2s',
        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      }}
    >
      <path
        d="M4 6L8 10L12 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : null;

  if (!item.dropdown) {
    return (
      <a
        href={item.href}
        aria-label={item.ariaLabel}
        className="flex items-center gap-1 hover:opacity-80"
        onClick={telemetryClickHandler(
          item.telemetrySlug,
          item.telemetryEvents
        )}
      >
        <img
          src={item.stockblocksIcon || item.icon}
          alt=""
          width={24}
          height={24}
        />
        {item.label && <span className={linkLabelClassName}>{item.label}</span>}
        {chevronSvg}
      </a>
    );
  }

  return (
    <div
      className="relative"
      onMouseEnter={(): void => setIsOpen(true)}
      onMouseLeave={(): void => setIsOpen(false)}
    >
      <button
        type="button"
        className="flex items-center gap-1 hover:opacity-80"
        aria-label={item.ariaLabel}
        onClick={telemetryClickHandler(
          item.telemetrySlug,
          item.telemetryEvents
        )}
      >
        <img
          src={item.stockblocksIcon || item.icon}
          alt=""
          width={24}
          height={24}
        />
        {item.label && (
          <span className="ml-2 text-sm font-normal text-gray-900">
            {item.label}
          </span>
        )}
        {chevronSvg}
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full z-50 mt-0 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-md whitespace-nowrap">
          <SingleColumnMenu links={item.dropdown.links} />
        </div>
      )}
    </div>
  );
}
